import axios from 'axios'
import { GetPaginationGuestDto, GuestModel } from '../features/guests/model'
import {
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
  ResponseObjectUpload,
} from '../../../models'
import { ObjectIdModule } from '../features/modules/models'

const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getGuestsService(dto: GetPaginationGuestDto) {
  return axios.post<ResponseObjectPaginated<GuestModel[]>>(`${BASEURL}/guest/getList`, dto)
}

export async function createGuestService(dto: GuestModel) {
  return await axios.post<ResponseObject<GuestModel>>(`${BASEURL}/guest/createGuest`, dto)
}

export async function getGuestByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<GuestModel>>(`${BASEURL}/guest/getGuestById`, {
    params: {
      Id: id,
    },
  })
}

export async function getGuestLastBookingByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<GuestModel>>(`${BASEURL}/guest/getGuestById`, {
    params: {
      Id: id,
      buscaUltReserva: true,
    },
  })
}

export async function editGuestService(dto: GuestModel) {
  return await axios.put<ResponseObject<GuestModel>>(`${BASEURL}/guest/updateGuest`, dto)
}

export async function deleteGuestService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<GuestModel>>(`${BASEURL}/guest/deleteGuest`, {
    data: dto,
  })
}

export function getTemplateGuestService() {
  return axios.post<ResponseObjectURL>(`${BASEURL}/guest/downloadTemplateBulkLoad`)
}

export function uploadTemplateGuestService(test: any) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/guest/bulkLoad`, test)
}

export function uploadSignatureGuestService(test: any, guestId: string) {
  return axios.post<ResponseObjectUpload>(
    `${BASEURL}/guest/saveSignatureTyC?guestId=${guestId}`,
    test,
  )
}

export function updateCargoGuestService(dto: { Id: string; CargoId: string }) {
  return axios.put<ResponseObject<any>>(`${BASEURL}/guest/updateCargoGuest`, dto)
}

export function updateTipoHuespedGuestService(dto: { Id: string; TipoHuespedId: string }) {
  return axios.put<ResponseObject<any>>(`${BASEURL}/guest/updateTipoHuespedGuest`, dto)
}